





















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import Table from '@c/tables/Table.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {TypeData} from '@/api/configurate';
import enumsModule from '@/store/modules/enumsModule';

@Component({
  components: {
    Table,
    SimpleDialog,
    SelectionList,
  },
})
export default class TableRoute extends Vue {
  @Prop() title!: string;
  @Prop({default: false, type: Boolean}) dense!: boolean;
  @Prop({default: true, type: Boolean}) editable!: boolean;
  @Prop({default: () => []}) headers!: DataTableHeader[];
  @Prop({default: 90}) actionsColumnWidth!: number;
  @Prop({default: null}) itemPageRouteName!: string | null;
  @Prop({default: 'id'}) itemKeyName!: string;
  @Prop({default: 'id'}) itemViewKeyName!: string;

  @Prop({required: true}) apiStore!: any;

  @Prop() typesStoreMap!: any;

  @Prop() hoverProp!: boolean;

  // типы элементов (для выбора при создании)
  @Prop() itemTypes!: TypeData[];

  // Модель диалога выбора типа элемента
  selectItemTypeDialog = false;

  // наименование журнала
  @Prop() nameJournal!: string;

  @Prop() isSensorPage!: boolean;

  editPath = this.isSensorPage ? 'EditSensor' : `Edit${this.itemPageRouteName}`;
  createPath = this.isSensorPage ? 'CreateSensor' : `Create${this.itemPageRouteName}`;

  @Watch('isSensorPage')
  onChange(val: boolean) {
    this.editPath = val ? 'EditSensor' : `Edit${this.itemPageRouteName}`;
    this.createPath = val ? 'CreateSensor' : `Create${this.itemPageRouteName}`;
  }

  // Действия при выборе типа элемента
  onSelectItemType() {
    const currentModule = enumsModule.moduleTypes.filter(
      (v: any) => v.value === this.selectedType?.type,
    );
    if (this.selectedType)
      this.$router.push({
        name: this.createPath,
        params: {type: currentModule[0].url},
      });
  }

  // показатель наличия типов
  get hasTypes() {
    return this.itemTypes?.length > 0;
  }

  // текущий выбранный тип
  get selectedType() {
    const findItems = this.itemTypes.filter((x: any) => x.id == this.selectedTypeId);
    if (findItems.length > 0) return findItems[0];
    return null;
  }

  get table() {
    return this.$refs.table as any;
  }

  getItemKey(item: any) {
    return item[this.itemKeyName];
  }

  // идентификатор выбранного типа
  selectedTypeId: any = null;

  // добавление новой записи
  add() {
    if (this.hasTypes) {
      this.selectItemTypeDialog = true;
    } else {
      this.$router.push({
        name: this.createPath,
      });
    }
  }

  // редактирование существующей записи
  edit(item: any) {
    const currentModule = enumsModule.moduleTypes.filter(v => v.value === item.type);
    if (currentModule.length > 0) {
      this.$router.push({
        name: this.editPath,
        params: {id: `${item.id}`, type: currentModule[0].url},
      });
    } else {
      this.$router.push({
        name: this.editPath,
        params: {id: `${item.id}`},
      });
    }
  }

  // редактирование существующей записи
  openDialog(item: any, edit: string) {
    const currentModule = enumsModule.moduleTypes.filter(v => v.value === item.type);
    if (currentModule.length > 0) {
      this.$router.push({
        name: this.editPath,
        params: {id: `${item.id}`, type: currentModule[0].url, openDialog: edit},
      });
    } else {
      this.$router.push({
        name: this.editPath,
        params: {id: `${item.id}`, openDialog: edit},
      });
    }
  }

  // удаление записи
  deleteItem(item: any) {
    this.table.deleteDialog.open(this.getItemKey(item), {
      deleteCallback: async (id: string) => {
        try {
          const module = this.hasTypes ? this.typesStoreMap.get(item.type) : this.apiStore;
          await module.delete(id);
          this.table.getData();
          this.table.deleteDialog.close();
        } catch (e) {
          this.table.deleteDialog.error('Произошла ошибка');
        }
      },
    });
  }

  onClickRow(item: any) {
    this.$emit('onClickRow', item);
  }
}
